export default {"src":"/_next/static/media/phone.d7b230f5.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};